import React from "react";
import styles from "./page1.module.scss";
import { Button } from "@mui/material";
import animated from "../../images/animated.png";
import video from "../../images/mainvideo.mp4";
import arrow from "../../images/arrowWhite.svg";
import shade from "../../images/shadeImage.svg";
import { useNavigate } from "react-router-dom";

export default function Page1() {
  const navigate = useNavigate();
  const handleButtonClick = () => {
    navigate("/LoginPage");
  };
  return (
    // <div className={styles.mainwrapper}>
    <div className={styles.mainbox}>
      <div className={styles.mainleft}>
        <div className={styles.heading}>
          <p className={styles.heading1}>
            Build Your Trading Application Using
          </p>
          <p className={styles.heading2}> Connect APIs</p>
        </div>

        <div>
          <p className={styles.para}>
            Firstock connect is the fastest,most secure trading APIs
          </p>
        </div>
        <div className={styles.button}>
          <Button
            startIcon={
              <div
                style={{
                  background: "#6D00FF",
                  borderRadius: "50%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  padding: "10px",
                }}
              >
                <img src={arrow} />
              </div>
            }
            variant="outlined"
            onClick={() => {
              window.open("https://wikiconnect.thefirstock.com/","_blank")
              //navigate("docsv3")
              // window.location.href =
              //   "https://connect.thefirstock.com/docsv3/docs/get-started/packages-instalation/";
            }}
            sx={{
              my: 2,
              color: "black",
              fontWeight: "600",

              // bgcolor: "#6D00FF",
              padding: "5px 20px 5px 10px",
              borderRadius: "50px",
              textTransform: "none",
              "&:hover": {
                bgcolor: "#6D00FF",
                transition: "0.3s ease-in-out",
                color: "white",
                "& .MuiButton-startIcon": {
                  transform: "rotate(45deg)",
                  transition: "0.3s ease-in-out",
                },
              },
            }}
          >
            Get Started
          </Button>
        </div>
      </div>
      <div className={styles.rightConainer}>
        <video autoPlay={true} loop muted className={styles.mainright}>
          <source
            src="https://firstock-common.s3.ap-south-1.amazonaws.com/projects/connect/landingvideo.mp4"
            type="video/mp4"
          />
        </video>
      </div>
    </div>
    // </div>
  );
}
